module.exports = __webpack_public_path__ + "static/media/Fanny-profile.3232f9e7.jpg";